import axiosInstance from "../../api/axiosInstance";
import Swal from 'sweetalert2';
export const saveFormData = (data, onSave) => {
    axiosInstance.post("medicalTemplates/save", data).then(response => {
        if (response.data.success) {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Saved Successfully',
            });
            onSave(true);
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response.data.message || 'Failed to save template. Please try again later.',
            });
            onSave(false);
        }
    }).catch(error => {
        Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to save template. Please try again later.',
        });
        onSave(false);
        console.error("Error saving template:", error);
    });
}